export default "__VITE_ASSET__3dae1834__"